module.exports = __webpack_public_path__ + "img/contributionIcon.399a4718.png";